var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { class: ["svg--" + _vm.name], style: { fill: "#" + _vm.getFill } },
    [
      _c("use", {
        attrs: {
          "xlink:href": _vm.static("svg/sprite.symbol.svg#" + _vm.name),
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }